import Image from 'next/image'
import { useTranslation } from 'next-i18next'
import { useNextLocale } from '@captaincause/lib/useNextLocale'
import individuals from 'assets/home-individuals.webp'
import { Button } from 'components/Button'

export function Individuals() {
  const { t } = useTranslation('home.page')

  return (
    <div className="relative overflow-hidden bg-purple">
      <div className="m-auto flex w-full max-w-[1400px] flex-col items-center justify-center gap-8 overflow-hidden px-4 py-10 md:flex-row md:px-20 md:py-14 lg:gap-6 lg:py-20">
        <div className="flex flex-col items-center gap-6 md:max-w-[60%] md:items-start lg:px-14">
          <h3 className="text-center font-default text-[40px] font-semibold leading-[48px] -tracking-[1.5px]">
            {t('individuals.title')}
          </h3>
          <p className="font-default text-xl font-medium leading-7 text-black">
            {t('individuals.subtitle')}
          </p>
          <p className="text-center font-default text-lg font-normal leading-7 text-black md:text-left">
            {t('individuals.body1')}
            <br />
            {t('individuals.body2')}
          </p>
          <Button
            href="/particuliers"
            variant="primary"
            className="rounded-[40px] border-gray px-7 py-3"
            locale={false}
          >
            {t('individuals.cta')}
          </Button>
        </div>
        <Image
          src={individuals}
          height={200}
          width={240}
          alt="c2c"
          className="hidden w-full max-w-[450px] object-contain md:block md:w-fit md:object-cover"
        />
      </div>
    </div>
  )
}
